import type { Store } from 'typesafe-actions';

import { MEMBER_API_ENDPOINT } from 'store/authCode/api';
import { setCommonError } from 'store/commonError/actions';

type ResponseInterceptorOptions = {
  response: Response;
  resolve: (value: unknown) => void;
  reject: (reason?: unknown) => void;
};

const responseInterceptor = (store: Store) => ({
  reject,
  response,
}: ResponseInterceptorOptions) => {
  // additional handler for maintenance mode
  //Ignore if the member API returns a 503 response when Everest token cannot be exchanged in case RID side is down.
  if (response.status === 503 && !response.url?.includes(MEMBER_API_ENDPOINT)) {
    store.dispatch(
      setCommonError({ message: 'Service is unavailable', httpStatusCode: response.status }),
    );
  } else if (response.status === 408) {
    store.dispatch(setCommonError({ message: 'Network error', httpStatusCode: response.status }));
  }
};

export default responseInterceptor;
